import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function PricingSection() {
  return <section className="py-24 bg-slate-50" id="pricing" data-id="element-173">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-176">
            Business Internet Plans
          </h2>
          <p className="text-lg text-slate-600" data-id="element-177">
            Promotional offers for new customers. Find the perfect speed for
            your business needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center max-w-6xl mx-auto" data-id="element-178">
          {/* Essential Plan */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 flex flex-col h-full" data-id="element-179">
            <div className="mb-6" data-id="element-180">
              <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-181">
                Essential
              </h3>
              <div className="flex items-baseline text-slate-900" data-id="element-182">
                <span className="text-4xl font-extrabold tracking-tight" data-id="element-183">
                  $69.99
                </span>
                <span className="text-slate-500 ml-1 font-medium" data-id="element-184">/mo</span>
              </div>
              <p className="text-sm text-slate-500 mt-2" data-id="element-185">Prices starting at</p>
            </div>

            <ul className="space-y-4 mb-8 flex-1" data-id="element-186">
              <li className="flex items-start" data-id="element-187">
                <CheckIcon className="w-5 h-5 text-green-500 mr-3 shrink-0 mt-0.5" data-id="element-188" />
                <span className="text-slate-700" data-id="element-189">
                  Up to <strong data-id="element-190">150 Mbps</strong> download
                </span>
              </li>
              <li className="flex items-start" data-id="element-191">
                <CheckIcon className="w-5 h-5 text-green-500 mr-3 shrink-0 mt-0.5" data-id="element-192" />
                <span className="text-slate-700" data-id="element-193">
                  Good for about <strong data-id="element-194">7 devices</strong>
                </span>
              </li>
              <li className="flex items-start" data-id="element-195">
                <CheckIcon className="w-5 h-5 text-green-500 mr-3 shrink-0 mt-0.5" data-id="element-196" />
                <span className="text-slate-700" data-id="element-197">
                  No annual contract required
                </span>
              </li>
            </ul>

            <a href="#quote" className="w-full block text-center bg-slate-100 hover:bg-slate-200 text-slate-900 font-semibold py-3 px-4 rounded-xl transition-colors" data-id="element-198">
              Get Started
            </a>
          </motion.div>

          {/* Standard Plan (Highlighted) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white rounded-2xl shadow-xl border-2 border-primary p-8 flex flex-col h-full relative md:scale-105 z-10" data-id="element-199">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-200">
              <span className="bg-primary text-white text-xs font-bold uppercase tracking-wider py-1 px-3 rounded-full" data-id="element-201">
                Most Popular
              </span>
            </div>

            <div className="mb-6" data-id="element-202">
              <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-203">
                Standard
              </h3>
              <div className="flex items-baseline text-slate-900" data-id="element-204">
                <span className="text-4xl font-extrabold tracking-tight" data-id="element-205">
                  $89.99
                </span>
                <span className="text-slate-500 ml-1 font-medium" data-id="element-206">/mo</span>
              </div>
              <p className="text-sm text-slate-500 mt-2" data-id="element-207">Prices starting at</p>
            </div>

            <ul className="space-y-4 mb-8 flex-1" data-id="element-208">
              <li className="flex items-start" data-id="element-209">
                <CheckIcon className="w-5 h-5 text-primary mr-3 shrink-0 mt-0.5" data-id="element-210" />
                <span className="text-slate-700" data-id="element-211">
                  Up to <strong data-id="element-212">300 Mbps</strong> download
                </span>
              </li>
              <li className="flex items-start" data-id="element-213">
                <CheckIcon className="w-5 h-5 text-primary mr-3 shrink-0 mt-0.5" data-id="element-214" />
                <span className="text-slate-700" data-id="element-215">
                  Good for about <strong data-id="element-216">12 devices</strong>
                </span>
              </li>
              <li className="flex items-start" data-id="element-217">
                <CheckIcon className="w-5 h-5 text-primary mr-3 shrink-0 mt-0.5" data-id="element-218" />
                <span className="text-slate-700" data-id="element-219">
                  <strong data-id="element-220">Security Edge™</strong> included
                </span>
              </li>
            </ul>

            <a href="#quote" className="w-full block text-center bg-primary hover:bg-primary-dark text-white font-semibold py-3 px-4 rounded-xl transition-colors shadow-md shadow-primary/20" data-id="element-221">
              Get Started
            </a>
          </motion.div>

          {/* Performance Plan */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 flex flex-col h-full" data-id="element-222">
            <div className="mb-6" data-id="element-223">
              <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-224">
                Performance
              </h3>
              <div className="flex items-baseline text-slate-900" data-id="element-225">
                <span className="text-4xl font-extrabold tracking-tight" data-id="element-226">
                  $119.99
                </span>
                <span className="text-slate-500 ml-1 font-medium" data-id="element-227">/mo</span>
              </div>
              <p className="text-sm text-slate-500 mt-2" data-id="element-228">Prices starting at</p>
            </div>

            <ul className="space-y-4 mb-8 flex-1" data-id="element-229">
              <li className="flex items-start" data-id="element-230">
                <CheckIcon className="w-5 h-5 text-green-500 mr-3 shrink-0 mt-0.5" data-id="element-231" />
                <span className="text-slate-700" data-id="element-232">
                  Up to <strong data-id="element-233">500 Mbps</strong> download
                </span>
              </li>
              <li className="flex items-start" data-id="element-234">
                <CheckIcon className="w-5 h-5 text-green-500 mr-3 shrink-0 mt-0.5" data-id="element-235" />
                <span className="text-slate-700" data-id="element-236">
                  Good for <strong data-id="element-237">17+ devices</strong>
                </span>
              </li>
              <li className="flex items-start" data-id="element-238">
                <CheckIcon className="w-5 h-5 text-green-500 mr-3 shrink-0 mt-0.5" data-id="element-239" />
                <span className="text-slate-700" data-id="element-240">
                  <strong data-id="element-241">Security Edge™</strong> included
                </span>
              </li>
            </ul>

            <a href="#quote" className="w-full block text-center bg-slate-100 hover:bg-slate-200 text-slate-900 font-semibold py-3 px-4 rounded-xl transition-colors" data-id="element-242">
              Get Started
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}